angular.module('unica_invitation_group.invitation_group_services')

.factory('InvitationGroupDeleteService', function ($http, getBaseApiURL) {

	var notificationDeleteService = {};

	notificationDeleteService.delete = function (notificationId) {
		return $http({
			method: 'DELETE',
			url: getBaseApiURL + '/invitation-group/delete/' + notificationId,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return true;
			}

		});

	};

	return notificationDeleteService;
});